import React from 'react';
import { Form, Input, Radio, Select, Space } from 'antd';
import {
  DEFAULT_PARAMS_SCHEMA,
  HTTP_AUTH_OPTIONS,
  HTTP_METHODS,
} from './toolFormUtils';

export default function AddHttpToolForm({ form, createMode, onCreateModeChange, onFinish }) {
  return (
    <>
      <Radio.Group
        value={createMode}
        onChange={(e) => onCreateModeChange(e.target.value)}
        style={{ marginBottom: 16 }}
        optionType="button"
        buttonStyle="solid"
        options={[
          { value: 'openapi', label: 'OpenAPI spec' },
          { value: 'single', label: 'Single endpoint' },
        ]}
      />
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ auth_type: 'none', http_method: 'GET', kind: 'read' }}
      >
        <Form.Item name="name" label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Form.Item name="base_url" label="Base URL" rules={[{ required: true }]}>
          <Input placeholder="https://api.example.com/v1" />
        </Form.Item>
        <Form.Item name="auth_type" label="Auth">
          <Select options={HTTP_AUTH_OPTIONS} />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(p, c) => p.auth_type !== c.auth_type}>
          {({ getFieldValue }) => getFieldValue('auth_type') === 'bearer' && (
            <Form.Item name="bearer_token" label="Bearer token">
              <Input.Password />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(p, c) => p.auth_type !== c.auth_type}>
          {({ getFieldValue }) => getFieldValue('auth_type') === 'api_key' && (
            <>
              <Form.Item name="api_key_header" label="API key header" initialValue="X-API-Key">
                <Input />
              </Form.Item>
              <Form.Item name="api_key_value" label="API key">
                <Input.Password />
              </Form.Item>
            </>
          )}
        </Form.Item>

        {createMode === 'openapi' ? (
          <>
            <Form.Item name="openapi_url" label="OpenAPI URL">
              <Input placeholder="https://api.example.com/swagger.json" />
            </Form.Item>
            <Form.Item name="openapi_spec_text" label="Or paste OpenAPI JSON">
              <Input.TextArea rows={6} placeholder='{"openapi":"3.0.0"}' style={{ fontFamily: 'monospace', fontSize: 12 }} />
            </Form.Item>
          </>
        ) : (
          <>
            <Form.Item name="tool_name" label="Tool name" rules={[{ required: true }]}>
              <Input placeholder="get_weather" />
            </Form.Item>
            <Form.Item name="tool_description" label="Tool description">
              <Input.TextArea rows={2} />
            </Form.Item>
            <Space style={{ width: '100%' }} size="middle">
              <Form.Item name="http_method" label="Method" style={{ flex: 1 }}>
                <Select options={HTTP_METHODS} />
              </Form.Item>
              <Form.Item name="kind" label="Kind" style={{ flex: 1 }}>
                <Select options={[{ value: 'read', label: 'Read' }, { value: 'write', label: 'Write' }]} />
              </Form.Item>
            </Space>
            <Form.Item name="path_template" label="Path (relative to base URL)" rules={[{ required: true }]}>
              <Input placeholder="/items/{id}" />
            </Form.Item>
            <Form.Item name="parameters_schema_text" label="Parameters JSON Schema" initialValue={DEFAULT_PARAMS_SCHEMA}>
              <Input.TextArea rows={6} style={{ fontFamily: 'monospace', fontSize: 12 }} />
            </Form.Item>
          </>
        )}
      </Form>
    </>
  );
}
